// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"9c3f06ff","268":"96f24ffd","457":"873f3cb8","551":"1ea0d1e5","842":"1ff660bf","950":"a6dc9b48"}[chunkId] + ".chunk.js";
};